import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { Info, History, Shield, Users, Award } from 'lucide-react';

interface TabItemProps {
  to: string;
  icon: React.ElementType;
  children: React.ReactNode;
}

function TabItem({ to, icon: Icon, children }: TabItemProps) {
  return (
    <NavLink
      to={to}
      end
      className={({ isActive }) =>
        cn(
          'flex items-center gap-2 border-b-2 px-4 py-3 text-sm font-medium transition-colors',
          'hover:text-primary hover:bg-primary/10 hover:border-primary/50',
          isActive
            ? 'border-primary text-primary'
            : 'border-transparent text-muted-foreground'
        )
      }
    >
      <Icon className="size-4" />
      <span>{children}</span>
    </NavLink>
  );
}

export default function DirectorioNacionalLayout() {
  return (
    <div className="flex h-full flex-col">
      {/* Header */}
      <div className="border-b border-border bg-card px-6 py-4">
        <div className="flex items-center gap-3">
          <Shield className="size-6 text-primary" />
          <div>
            <h1 className="text-2xl font-bold">Directorio Nacional</h1>
            <p className="text-sm text-muted-foreground">
              Autoridades nacionales de las Asambleas de Dios Bolivia
            </p>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="border-b border-border bg-card">
        <div className="flex gap-1 overflow-x-auto px-4">
          <TabItem to="/directorio-nacional/information" icon={Info}>
            Información
          </TabItem>
          <TabItem to="/directorio-nacional/miembros" icon={Users}>
            Miembros
          </TabItem>
          <TabItem to="/directorio-nacional/credenciales" icon={Award}>
            Credenciales
          </TabItem>
          <TabItem to="/directorio-nacional/historial" icon={History}>
            Historial
          </TabItem>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-auto bg-background">
        <Outlet />
      </div>
    </div>
  );
}
